import { storage } from 'app/utils/localStorage';
export function settings() {
    const lc = storage('settings');
    const get = () => {
        try {
            return JSON.parse(lc.get() || '{}');
        }
        catch (_) {
            return {};
        }
    };
    return {
        get,
        set: (key, value) => {
            const current = get();
            try {
                const next = Object.assign(Object.assign({}, current), { [key]: value });
                if (value === undefined) {
                    delete next[key];
                }
                lc.set(JSON.stringify(next));
                return next;
            }
            catch (_) {
                return current;
            }
        },
    };
}
